import getCookie from './getCookie.js';

export default function getCSRFCookie() {
  return getCookie('csrf');
}
